var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 2.06667C1.33301 1.6933 1.33301 1.50661 1.40567 1.36401C1.46959 1.23856 1.57157 1.13658 1.69701 1.07266C1.83962 1 2.02631 1 2.39967 1H13.5997C13.973 1 14.1597 1 14.3023 1.07266C14.4278 1.13658 14.5298 1.23856 14.5937 1.36401C14.6663 1.50661 14.6663 1.6933 14.6663 2.06667V2.51293C14.6663 2.69213 14.6663 2.78173 14.6444 2.86504C14.625 2.93887 14.5931 3.00882 14.55 3.07184C14.5014 3.14295 14.4337 3.20164 14.2983 3.319L10.0344 7.01434C9.899 7.1317 9.83129 7.19038 9.78267 7.26149C9.73958 7.32451 9.70764 7.39446 9.68824 7.46829C9.66634 7.55161 9.66634 7.64121 9.66634 7.8204V11.3056C9.66634 11.436 9.66634 11.5011 9.64531 11.5575C9.62673 11.6073 9.59652 11.6519 9.55718 11.6877C9.51266 11.7281 9.45213 11.7524 9.33108 11.8008L7.06442 12.7074C6.81939 12.8054 6.69687 12.8545 6.59852 12.834C6.51252 12.8161 6.43704 12.765 6.38851 12.6918C6.33301 12.6081 6.33301 12.4762 6.33301 12.2122V7.8204C6.33301 7.64121 6.33301 7.55161 6.31111 7.46829C6.29171 7.39446 6.25977 7.32451 6.21668 7.26149C6.16806 7.19038 6.10035 7.1317 5.96493 7.01434L1.70108 3.319C1.56566 3.20164 1.49796 3.14295 1.44934 3.07184C1.40625 3.00882 1.37431 2.93887 1.35491 2.86504C1.33301 2.78173 1.33301 2.69213 1.33301 2.51293V2.06667Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter_icon.107b9d6af4122d5942edc5af0a954f96.svg";
export { ForwardRef as ReactComponent };